var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { REACT_APP__URL_SMP_API, REACT_APP__URL_STORAGE_STATIC, } from "@smp/utils";
import { apiRequest } from "../../../lib";
const objectParamsToFormData = (params) => {
    var _b;
    const fd = new FormData();
    const templateFile = params.template_file &&
        new Blob([JSON.stringify(params.template_file)], {
            type: "text/plain",
        });
    templateFile && fd.append("template_file", templateFile);
    params.height && fd.append("height", params.height.toString());
    params.width && fd.append("width", params.width.toString());
    params.thumbnail && fd.append("thumbnail", params.thumbnail);
    params.name && fd.append("name", params.name);
    (_b = params.system_templates) === null || _b === void 0 ? void 0 : _b.forEach((url, idx) => {
        fd.append(`system_templates[${idx}]`, url);
    });
    return fd;
};
export class ApiSmpArtGalleryPolotno {
}
_a = ApiSmpArtGalleryPolotno;
/**
 * Used to create new user template
 */
ApiSmpArtGalleryPolotno.createUserTemplate = (params) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        body: objectParamsToFormData(params),
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/polotno-v2/",
        method: "POST",
    });
});
/**
 * Used to delete existing user template by id
 */
ApiSmpArtGalleryPolotno.destroyUserTemplate = (id) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/polotno-v2/${id}`,
    method: "DELETE",
});
/**
 * Used to list existing user template
 */
ApiSmpArtGalleryPolotno.userTemplates = (params, next) => __awaiter(void 0, void 0, void 0, function* () {
    return yield apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/polotno-v2/",
        method: "GET",
        next,
        query: params,
    });
});
/**
 * Used to update existing user template
 */
ApiSmpArtGalleryPolotno.updateUserTemplate = (_b) => {
    var { id } = _b, params = __rest(_b, ["id"]);
    return apiRequest({
        body: objectParamsToFormData(params),
        endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/polotno-v2/${id}`,
        method: "PUT",
    });
};
/**
 * Used to patch existing user template
 */
ApiSmpArtGalleryPolotno.patchUserTemplate = (_b) => {
    var { id } = _b, params = __rest(_b, ["id"]);
    return apiRequest({
        body: objectParamsToFormData(params),
        endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/polotno-v2/${id}`,
        method: "PATCH",
    });
};
/**
 * Used to list smmplanner designs
 */
ApiSmpArtGalleryPolotno.templates = (query) => __awaiter(void 0, void 0, void 0, function* () {
    return yield apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/template/json/index",
        method: "GET",
        query,
    });
});
/**
 * Used to entity smmplanner designs
 */
ApiSmpArtGalleryPolotno.template = ({ id, text_lang, }) => __awaiter(void 0, void 0, void 0, function* () {
    const idInt = Number(id) || undefined;
    const alt = (!idInt && typeof id === "string" && id.split("-")) || undefined;
    if (!idInt && (!(alt === null || alt === void 0 ? void 0 : alt[0]) || !(alt === null || alt === void 0 ? void 0 : alt[1]))) {
        return Promise.reject(new Response("Page not found", {
            status: 404,
            statusText: "Not Found",
        }));
    }
    return apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/art-gallery/v1/template/json/index`,
        method: "GET",
        query: {
            id: idInt,
            number: alt === null || alt === void 0 ? void 0 : alt[1],
            pack: alt === null || alt === void 0 ? void 0 : alt[0],
            text_lang,
        },
    }).then((resp) => {
        const firstTemplate = resp.results.at(0);
        if (!firstTemplate) {
            return Promise.reject(new Response("Page not found", {
                status: 404,
                statusText: "Not Found",
            }));
        }
        return firstTemplate;
    });
});
/**
 * Used to list smmplanner design tags
 */
ApiSmpArtGalleryPolotno.templateTags = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield apiRequest({
        endpoint: REACT_APP__URL_STORAGE_STATIC + "/polotno/templates/tags.json",
        method: "GET",
    });
});
/**
 * Used to list smmplanner design tags
 */
ApiSmpArtGalleryPolotno.tags = (query) => __awaiter(void 0, void 0, void 0, function* () {
    return yield apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/tag/json/index",
        method: "GET",
        query,
    });
});
/**
 * Used to list stickers
 */
ApiSmpArtGalleryPolotno.stickerpacks = (query) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/stickerpack/json/index",
        method: "GET",
        query,
    });
});
/**
 * Used to list stickers
 */
ApiSmpArtGalleryPolotno.stickers = (query) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/sticker/json/index",
        method: "GET",
        query,
    });
});
/**
 * Used to list stickers
 */
ApiSmpArtGalleryPolotno.sticker = ({ id, text_lang, }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/sticker/${id}/index`,
        method: "GET",
        query: {
            text_lang,
        },
    });
});
/**
 * Used to stickerpack entity
 */
ApiSmpArtGalleryPolotno.stickerpack = ({ id, text_lang, }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/art-gallery/v1/stickerpack/json/index`,
        method: "GET",
        query: {
            id,
            text_lang,
        },
    }).then((resp) => {
        const firstStickerpack = resp.results.at(0);
        if (!firstStickerpack) {
            return Promise.reject(new Response("Page not found", {
                status: 404,
                statusText: "Not Found",
            }));
        }
        return firstStickerpack;
    });
});
/**
 * Used to list stickers
 */
ApiSmpArtGalleryPolotno.shapes = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield apiRequest({
        endpoint: REACT_APP__URL_STORAGE_STATIC +
            "/polotno/shapes/index.json?t=" +
            Date.now(),
        method: "GET",
    });
});
//# sourceMappingURL=polotno.js.map